<script setup>
import { computed } from "vue"
import { achievements } from "../../staticData"
import { storage } from '../../storage'

import ModalBlock from '../ModalBlock'
import AchievementItem from './AchievementItem'
defineEmits(['hide-achievements', 'show-new-achievement'])
defineProps(['display'])
let tasksAll = 0
Object.keys(achievements).forEach(k => {
    tasksAll += achievements[k].values.length
})

const tasksDone = computed(() => {
    let res = 0
    Object.keys(storage.ACHIEVEMENTS).forEach(k => {
        res += storage.ACHIEVEMENTS[k]
    })
    return res
})
</script>

<template>
   <ModalBlock @closeWindow="$emit('hide-achievements')" :height="'fit-content'" :boxSizing="'content-box'" :display="display">
        <template #header>
            <h3>Achievements</h3>
            <div class="row"> 
               <p>Done {{ tasksDone }} / {{ tasksAll }}</p>
            </div>
        </template>
        <template #main>
            <div class="column-2-list">
                <AchievementItem v-for="(achievement, key) in achievements" :key="'upgrade-' + key" :task="achievement" :keyName="key" @new-achievement="$emit('show-new-achievement')" />
            </div>
        </template>
    </ModalBlock>
</template>

<style scoped>
/* #window {
    display: v-bind(display);
} */

.column-2-list {
    display: grid;
    justify-content: center;
    grid-template-columns: 350px 350px;
    column-gap: 0.625rem;
    row-gap: 0.625rem;
    background-color: antiquewhite;
    border-radius: 20px;
    padding: 0.625rem 0;
}

/* 
.column-2-list>div:nth-child(odd) {
    border-right: 1px solid white;
    margin-right: 10px;
}

.column-2-list>div {
    border-bottom: 1px solid white;
    margin-bottom: 10px;
} */

.row {
    justify-content: center;
    align-items: center;
}

.row p {
    font-size: 1.1rem;
}

.row span {
    font-size: 1rem;
}

.row img {
    margin-left: 10px;
}

@media screen and (max-width: 1000px) {

    .column-2-list {
        grid-template-columns: 48% 48%;
    }

}
</style>